
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Technology = lazy(() => import('../pages/technology/page'));
const Partners = lazy(() => import('../pages/partners/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Careers = lazy(() => import('../pages/careers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/technology',
    element: <Technology />
  },
  {
    path: '/partners',
    element: <Partners />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/careers',
    element: <Careers />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
